import Vue from "vue";
import Vuex from "vuex";
import ai from "./modules/ai";
import { banner } from "./modules/banner";
import { cover } from "./modules/cover";
import { poster } from "./modules/poster";
import { posterLong } from "./modules/poster-long";
import { skin } from "./modules/skin";
import { subCover } from "./modules/sub-cover";
Vue.use(Vuex);
var store = new Vuex.Store({
  modules: {
    banner,
    cover,
    poster,
    posterLong,
    skin,
    subCover,
    ai,
  },
  state: {
    userInfo: {},
    scale: 100,
    nextControl: -1,
  },
  mutations: {
    changeUser (state, params) {
      state.userInfo = params;
    },
    updataScale (state, value) {
      state.scale += parseInt(value);
    },
    updataNextControl (state, nextControl) {
      state.nextControl = nextControl;
    },
  },
});
export default store;
